/**
 * Validação/conversão de intervalo para o backfill de agregações. Separado
 * do componente `BackfillButton` para manter o módulo de UI só com exports de
 * componente (regra `react-refresh/only-export-components`) e deixar a regra
 * testável sem montar React.
 */

/** ISO `YYYY-MM-DD` → `yyyymmdd` (formato dos docs de agregação). */
export function isoToYyyymmdd(iso: string): string {
  return iso.replace(/-/g, '');
}

export type PreparedBackfill =
  | { ok: true; fromYyyymmdd: string; toYyyymmdd: string }
  | {
      ok: false;
      errorKey:
        | 'backfill.errorNoRange'
        | 'backfill.errorOrder'
        | 'backfill.errorFuture';
    };

/**
 * Valida o intervalo e converte para `yyyymmdd`. Comparar ISO `YYYY-MM-DD`
 * como string é equivalente a comparar cronologicamente, então `from > to`
 * pega a inversão de ordem e `to > todayIso` pega data futura (o DatePicker
 * desabilita o clique em datas futuras, mas o campo é digitável). `todayIso`
 * é injetado (em vez de `Date.now` interno) para manter a função pura.
 */
export function prepareBackfill(
  from: string,
  to: string,
  todayIso: string,
): PreparedBackfill {
  if (!from || !to) return { ok: false, errorKey: 'backfill.errorNoRange' };
  if (from > to) return { ok: false, errorKey: 'backfill.errorOrder' };
  if (to > todayIso) return { ok: false, errorKey: 'backfill.errorFuture' };
  return {
    ok: true,
    fromYyyymmdd: isoToYyyymmdd(from),
    toYyyymmdd: isoToYyyymmdd(to),
  };
}
